import BaseAPI from './BaseAPI'

export default class UserAPI extends BaseAPI{
    static getUsers() {
        return this.execute('get', '/users')
    }

    static getUser(id) {
        return this.execute('get', `/users/${id}`)
    }

    static getCurrentUser() {
        return this.execute('get', '/users/current')
    }

    static getUserGroups(id) {
        return this.execute('get', `/users/${id}/groups`)
    }

    static setUserGroups(id, data) {
        return this.execute('post', `/users/${id}/groups`, data)
    }

    static createUser(data) {
        return this.execute('post', '/users', data)
    }

    static updateUser(id, data) {
        return this.execute('patch', `/users/${id}`, data)
    }

    static deleteUser(id) {
        return this.execute('delete', `/users/${id}`)
    }
}



// WEBPACK FOOTER //
// ./src/api/UserAPI.js